/** French perimeter-and-area prompts (ADR 0051 part 3). */
/** A no-break space (WinAnsi 0xA0), so a question mark is never left at the head of a line. */
const NO_BREAK = String.fromCharCode(0xa0);

export const shapePrompts = {
    // Shorter than "Quel est le côté manquant ?" on purpose - ADR 0051 §7
    // part 3's measurement found the longer phrasing pushed the Missing Side
    // question over the page at full 8 and half 3 (with answer keys), a
    // count that was already tight in English. See docs/plans/README.md.
    missingSide: (area: string) => `L'aire est ${area}. Quel côté manque ?`,
    perimeter: () => `Quel est le périmètre ?`,
    area: () => `Quelle est l'aire ?`,
    // Scale Drawing (ADR 0107). The French space before the colon, as elsewhere.
    scaleLine: (scale: string) => `Échelle : ${scale}`,
    actualSize: () => `Quelles sont la longueur et la largeur réelles ?`,
    actualArea: () => `Quelle est l'aire réelle ?`,
    drawingLength: (actual: string) => `Le côté marqué${NO_BREAK}? mesure ${actual} en réalité. Quelle est sa longueur sur le dessin ?`,
    anotherScale: (scale: string) => `On redessine la figure à l'échelle ${scale}. Quelles sont les nouvelles dimensions ?`,
    /** "24 m sur 16 m". */
    bySize: (length: string, width: string) => `${length} sur ${width}`,
};
